module.exports = __webpack_public_path__ + "static/7-1398f7ad17588bd657ad459ee5f370a1.png";